import React, { Fragment, useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import {
  Button,
  Card,
  CardBody,
  CardText,
  Col,
  Container,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import { useInsertConText } from "../Context/InsertContext";
import axios from "axios";
import { GetCookieToken } from "../Cookie/GetCookie";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFViewer,
  Font,
} from "@react-pdf/renderer";
import { useLayOutConText } from "../Context/LayOutContext";
import { FetchAxiosGet } from "../../api/axios";
import Lottie from "react-lottie";
import * as loadingLeaveSumary from "../../assets/lottieAnimation/loadingLeaveSumary.json"
import { checkExpectLevel } from "./evaluateConfig";
import { createBehaviorRows, shouldUseOldBehaviorRows } from "./shared/behaviorTemplate";

const API_URL = process.env.REACT_APP_API_CORS;
function Form2PDF(props) {
  const {
    budgetYear,
    round,
    evaluateSalaryID,
    userID,
    userName,
    updateApprove,
    task,
    approveId,
    version,
    confirmSignnum,
    checkSingnum = true,
    evaluateDataItem,
    approveCheckPointUser,
    checkPointApproved = null,
    lastStepApproved = null,
  } = props;

  let assessor1 = evaluateDataItem?.evaluateSalaryFlow.find(x => x?.assessor === 1)

  const [loading, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState([]);
  const [calculatedValues, setCalculatedValues] = useState(null);
  const [FormData_1, setFormData_1] = useState(null);
  const [dataInfo, setDataInfo] = useState([]);
  const [modal, setModal] = useState(false);
  const [approveInfo, setApproveInfo] = useState([]);
  const [masterdata, setMasterdata] = useState([]);
  const [appUser, setAppUser] = useState(null)
  const [userFullNameLv1, setUserFullNameLv1] = useState(null)
  const [userPosition, setUserPosition] = useState(null)
  const [aproveFullNameLv1, setAproveFullNameLv1] = useState(null)
  const [aprovePosition, setAprovePosition] = useState(null)
  const [positionHighLevel, setPositionHighLevel] = useState(null)
  const [evaluateApprove, setEvaluateApprove] = useState(null)

  // ใบประเมินปี 2569 รอบ 1 และปีก่อนหน้า ใช้สมรรถนะชุดเก่า
  const useOldBehaviorRows = shouldUseOldBehaviorRows(budgetYear, round);

  const [formTwoData, setFormTwoData] = useState(() => createBehaviorRows(false, null, useOldBehaviorRows));
  const [evaluateDataBehavior, setEvaluateDataBehavior] = useState([]);
  const [evaluateBehaviorLoaded, setEvaluateBehaviorLoaded] = useState(false);

  const toggle = () => setModal(!modal);

  const token = GetCookieToken("userToken");

  const fetchStepStatus = async(evaluateSalaryId) =>{
    const params = new URLSearchParams({
          page: 1,
          size: 100,
          "order[0]": "evaluate_salary_approve_id",
          "order[1]": "DESC",
          "filter[evaluate_salary_id][0]": evaluateSalaryId,
        });
    const evaluateApprove = await FetchAxiosGet("/api/evaluateSalaryApprove/datatable",token,params)
    const filteredData = evaluateApprove.result.map(item => ({
      evaluate_status: item.evaluate_status,
      approve_user: item.approve_user,
      approve_user_id: item.approve_user_id
    }));
    let status
    if (task === 1) {
      status = 1
      return status
    } else if(task === 2) {
      // status = filteredData?.find(x => x.evaluate_status === task)
      // setAppUser(status?.approve_user)
      //   if (status?.approve_user_id !== undefined && status?.approve_user_id !== null) {
      //     const positionApprove = await FetchAxiosGet(`/api/users/${Number(status?.approve_user_id)}`,token)
      //     setPositionHighLevel(positionApprove.result.user_position_name)
      //   }
      // return status?.evaluate_status
    } else if(task === 3) {
      status = 3
      return status
    }
  }

  const fetchEvaluateBehavior = async () => {
    const status = await fetchStepStatus(evaluateSalaryID)
    const new_buggetyer_migrate = 2568
    const url = `${API_URL}/api/evaluateSalaryBehavior/datatable`;
    let params 
    if (status !== undefined && budgetYear >= new_buggetyer_migrate) {
      params = new URLSearchParams({
        page: 1,
        size: 10,
        "order[0]": "user_id",
        "order[1]": "ASC",
        "filter[budget_year][0]": budgetYear,
        "filter[round][0]": round,
        "filter[evaluate_salary_id][0]": evaluateSalaryID,
        "filter[created_user_id][0]": (lastStepApproved && assessor1) ? assessor1?.approve_user_id : (checkPointApproved ? approveCheckPointUser?.approve_user_id : userID),
        // "filter[step_status][0]": status,
        "currentVersion": 1,
      });
    } else {
      params = new URLSearchParams({
        page: 1,
        size: 10,
        "order[0]": "user_id",
        "order[1]": "ASC",
        "filter[budget_year][0]": budgetYear,
        "filter[round][0]": round,
        "filter[evaluate_salary_id][0]": evaluateSalaryID,
        "filter[user_id][0]": userID,
        "filter[created_user_id][0]": (lastStepApproved && assessor1) ? assessor1?.approve_user_id : (checkPointApproved ? approveCheckPointUser?.approve_user_id : userID),
        "currentVersion": 1,
      });
    }

      checkPointApproved && console.log(params);
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    // await axios
    //   .get(url, config)
    //   .then(response => {
    //     setFormTwoData(prevFormTwoData => {
    //       const updatedFormTwoData = prevFormTwoData.map(formItem => {
    //         const matchingEvaluateData = response.data.result.find(
    //           evalItem => evalItem.no === formItem.no
    //         );

    //         return {
    //           ...formItem,
    //           score: matchingEvaluateData ? matchingEvaluateData.score : "",
    //         };
    //       });

    //       return updatedFormTwoData;
    //     });
    //     // setEvaluateData(response.data.result);
    //   })
    //   .catch(error => console.error("Error:", error));
    await axios
    .get(url, config)
    .then(response => {
      // เก็บผลดิบไว้ก่อน ให้ useEffect ที่รอ userInfo.user_level_id
      // (เพิ่มด้านล่าง) เป็นคนสร้าง formTwoData ด้วยชุดแถวที่ถูกต้องตามสมรรถนะ
      setEvaluateDataBehavior(response.data.result);
      setEvaluateBehaviorLoaded(true);
    })
    .catch(error => console.error("Error:", error));
  };

  useEffect(() => {
    const letEffect = async () =>{
      setLoading(true)
        await fetchEvaluateBehavior();
      setTimeout(() => {
        setLoading(false)
      }, 2500);
    }
    letEffect()
  }, [budgetYear,round,evaluateSalaryID,userID,userName,updateApprove,task]);

  useEffect(() => {
    if (!evaluateBehaviorLoaded) return;

    const rebuilt = createBehaviorRows(false, userInfo.user_level_id, useOldBehaviorRows).map(row => {
      const matched = evaluateDataBehavior.find(evalItem => evalItem.no === row.no);
      return {
        ...row,
        score: matched ? matched.score : "",
      };
    });

    setFormTwoData(rebuilt);
  }, [userInfo?.user_level_id, evaluateBehaviorLoaded, evaluateDataBehavior]);

  const pdfRef = useRef();

  const [buttonLoading, setButtonLoading] = useState(false)
  const downloadPDF = async () => {
    setButtonLoading(true)
    const input = pdfRef.current;
    await html2canvas(input, { scale: 2 }).then(canvas => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("l", "mm", "a4", true); //แนวนอน
      // const pdf = new jsPDF("", "mm", "a4", true);   //แนวตั้ง
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const imgX = (pdfWidth - imgWidth * ratio) / 2;

      const imgY = 5;
      pdf.addImage(
        imgData,
        "PNG",
        imgX,
        imgY,
        imgWidth * ratio,
        imgHeight * ratio
      );
      pdf.save("แบบประเมินพฤติกรรมการปฏิบัติราชการหรือสมรรถนะ.pdf");
      setTimeout(() => {
        setButtonLoading(false)
      }, 1000);
    });
  };

  useEffect(() => {
    const url = `${API_URL}/api/users/${userID}`;
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then(response => {
        setDataInfo(response.data.result);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    const calculatedValues = formTwoData.map(
      (group, index) => (group.score * group.percentage) / 100
    );
    const sum = calculatedValues.reduce(
      (accumulator, currentValue) => accumulator + currentValue.toFixed(4) * 1,
      0
    );
    
    setCalculatedValues(sum.toFixed(4));
    setFormData_1((sum * (100 / 5)).toFixed(4));
  }, [formTwoData]);

  useEffect(() => {
    if (updateApprove !== null && updateApprove !== undefined) {
      const url = `${API_URL}/api/users/${updateApprove.approve_user_id}`;
      const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
      };
      axios
        .get(url, config)
        .then(response => {
          setApproveInfo(response.data.result);
        })
        .catch(error => {
          console.error(error);
        });
    }
  }, []);

  const fetchMasterData = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/users/config/all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setMasterdata(response.data.result);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  useEffect(() => {
    const url = `${API_URL}/api/users/${userID}`;
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then(response => {
        setUserInfo(response.data.result);
      })
      .catch(error => {
        console.error(error);
      });
    fetchMasterData();
  }, []);

  let filteredMasterDataPostion;

  const typeEMP = masterdata.user_type_emp?.find(
    i => i.type_emp_id === parseInt(userInfo.user_category_id, 10)
  );
  if (typeEMP && typeEMP.user_level_emp !== undefined) {
    filteredMasterDataPostion = typeEMP.user_level_emp?.filter(
      item => item.level_emp_id === userInfo.user_level_id
    );
  }

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => { window.removeEventListener('resize', handleResize) };
  }, []);

  const fetchFullName = async (userID, setFullName, wit = false) => {
    const url = `/api/users/${userID}`;
    let tietleName
    let name
    let fullName
    let witnessUser

    const res = await FetchAxiosGet(url,token).then(ress =>{
      tietleName = ress.result?.user_title_name
      name = ress.result?.user_name
      fullName = `${tietleName}${name}`
      witnessUser = ress.result?.user_position_name
      if (wit) {
        setFullName(witnessUser)
      } else {
        setFullName(fullName)
      }
    }).catch(err => {console.error(err); return null;}) 
  }

  const fetchWitessApporve = async () => {
    const params = new URLSearchParams({
      page: 1,
      size: 100,
      "order[0]": "evaluate_salary_approve_id",
      "order[1]": "ASC",
      "filter[evaluate_salary_id][0]": evaluateSalaryID,
    });
    const evaluateApprove = await FetchAxiosGet("/api/evaluateSalaryApprove/datatable",token,params)
    const index = evaluateApprove?.result.findIndex(x => x.approve_user_id == approveId && x.version == version)
    setEvaluateApprove(evaluateApprove?.result)
  }

  useEffect(() => {
    // fetchFullName(approveId, setAproveFullNameLv1)
    // fetchFullName(approveId, setAprovePosition, true)

    let evaluateFlow = evaluateDataItem?.evaluateSalaryFlow ?? []
    let thisApproveFlow = evaluateFlow?.find(x => x.approve_user_id === approveCheckPointUser?.approve_user_id)
    fetchFullName(thisApproveFlow?.approve_user_id, setAproveFullNameLv1)
    setAprovePosition(thisApproveFlow?.approve_user_position_name)

    fetchFullName(userID, setUserFullNameLv1)
    setUserPosition(evaluateDataItem?.evaluate_user_position_name ?? '-')
    fetchWitessApporve()
  }, [])
  


  return (
    <Fragment>
      <Button
        color="success"
        className="mb-1 text-nowrap"
        onClick={() => {toggle()}}
      >
        แบบฟอร์มที่ 2
      </Button>
      <Modal size="xl" centered isOpen={modal} toggle={toggle}>
        <ModalHeader>
          <div className="position-absolute top-0 end-0">
            <i className="fa-sharp fa-solid fa-circle-xmark pt-2 pe-3 h4" style={{cursor: "pointer"}} onClick={toggle}></i>
          </div>
        </ModalHeader>
        <ModalBody className="px-5" style={{ overflowX: "scroll"}}>
          {loading ?
            <div>
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: loadingLeaveSumary.default,
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                  }}
                  width={200}
                  height={200}
              />
            </div>
          : <Fragment>
              <div ref={pdfRef} style={{ minWidth:"1106px"}}>
                <Container
                  fluid
                  className="ps-4 pe-4"
                  style={{ fontFamily: "Sarabun,serif" }}
                >
                  <Row>
                    <Col lg={12} className="text-end pe-4">
                      <i>แบบฟอร์มหมายเลข 2</i>
                    </Col>
                  </Row>
                  <br />
                  <Row className="mt-2">
                    <Col xs={5} md={5} lg={5}>
                      <strong className="border border-2 border-black rounded-3 p-2 shadow-sm fs-5">
                        แบบประเมินพฤติกรรมการปฏิบัติราชการหรือสมรรถนะ
                      </strong>
                      <label className="pt-2 ps-2">
                        <strong>(สำหรับประเภทวิชาการและประเภททั่วไป)</strong>
                      </label>
                    </Col>
                    <Col xs={7} md={7} lg={7}>
                        <Row>
                          <Col xs={3} md={3} lg={3}>
                            <strong>รอบการประเมิน</strong>
                          </Col>
                          <Col xs={3} md={3} lg={3}>
                            <strong className="border border-2 border-black p-1 me-2">
                              {round === 1 ? <i className="fa-solid fa-check py-2 p-2 fa-2xl"></i> : <i className="py-2 p-3"></i>}
                            </strong>
                            <strong>รอบที่ 1</strong>
                          </Col>
                          <Col xs={3} md={3} lg={3}>
                            <strong className="border border-2 border-black p-1 me-2">
                            {round === 2 ? <i className="fa-solid fa-check py-2 p-2 fa-2xl"></i> : <i className="py-2 p-3"></i>}
                            </strong>
                            <strong>รอบที่ 2</strong>
                          </Col>
                        </Row>
                    </Col>
                  </Row>

                  <Row className="mt-3">
                    <Col xs={7} md={7} lg={7}>
                      ชื่อผู้รับการประเมิน
                      <span
                        className="ps-2 "
                        style={{
                          borderBottomStyle: "dotted",
                          borderWidth: "2px",
                          width: "300px",
                          display: "inline-block",
                        }}
                      >
                        <strong>{userFullNameLv1}</strong>
                      </span>
                    </Col>

                    <Col xs={5} md={5} lg={5}>
                      ลงนาม
                      <span className="ps-2 " style={{ borderBottomStyle: "dotted", borderWidth: "2px", width: "350px", display: "inline-block"}}>
                        <strong>{userName}</strong>
                      </span>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col xs={5} md={5} lg={5} className="pe-0">
                      ตำแหน่ง
                      <span
                        className="ps-2 "
                        style={{
                          borderBottomStyle: "dotted",
                          borderWidth: "2px",
                          width: "356px",
                          display: "inline-block",
                        }}
                      >
                        <strong>{userPosition}</strong>
                      </span>
                    </Col>
                    <Col xs={4} md={4} lg={4} className="ps-0">
                      ระดับ
                      <span
                        className="ps-2 "
                        style={{
                          borderBottomStyle: "dotted",
                          borderWidth: "2px",
                          width: "122px",
                          display: "inline-block",
                        }}
                      >
                        <strong>
                          {filteredMasterDataPostion
                            ?.map(i => i.level_emp_name)
                            .toString()}
                        </strong>
                      </span>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col xs={7} md={7} lg={7}>
                      ชื่อผู้บังคับบัญชา/ผู้ประเมิน
                      <span
                        className="ps-2"
                        style={{
                          borderBottomStyle: "dotted",
                          borderWidth: "2px",
                          width: "450px",
                          display: "inline-block",
                        }}
                      >
                        <strong>
                          {/* {appUser !== null ? appUser :
                            updateApprove?.approve_user !== undefined &&
                            updateApprove?.approve_user !== null
                              ? updateApprove?.approve_user
                              : "" } */}
                            {aproveFullNameLv1}
                        </strong>
                      </span>
                    </Col>
                    <Col xs={5} md={5} lg={5}>
                      ลงนาม
                      <span className="ps-2 " style={{ borderBottomStyle: "dotted", borderWidth: "2px", width: "350px", display: "inline-block"}}>
                        <strong>
                          {checkSingnum && evaluateApprove?.find(x => x.approve_user_id == approveId && x.version == version)?.approve_signnum}
                        </strong>
                      </span>
                    </Col>
                  </Row>
                  <Row className="mb-2 mt-3">
                    <Col xs={12} md={12} lg={12}>
                      ตำแหน่ง
                      <span
                        className="ps-3"
                        style={{
                          borderBottomStyle: "dotted",
                          borderWidth: "2px",
                          width: "547.5px",
                          display: "inline-block",
                        }}
                      >
                        <strong>
                          {/* {positionHighLevel !==null ? positionHighLevel : updateApprove !== null && updateApprove !== undefined
                            ? approveInfo.user_position_name
                            : ""} */}
                          {aprovePosition}
                        </strong>
                      </span>
                    </Col>
                    {/* <Col lg={4}>
                      ระดับ
                      <span className="ps-3">
                        <strong>{dataInfo.user_level_name}</strong>
                      </span>
                    </Col> */}
                  </Row>
                  <table className="border border-1 border-black">
                    <thead className="table-light" style={{ whiteSpace: "nowrap" }}>
                      <tr>
                        <th className="text-center border border-1 border-black">
                          สมรรถนะ
                        </th>
                        <th className="text-center border border-1 border-black">
                          ระดับที่คาดหวัง
                        </th>
                        <th className="text-center border border-1 border-black">
                          คะแนน
                          <br />
                          (ก)
                        </th>
                        <th className="text-center border border-1 border-black">
                          น้ำหนัก
                          <br />
                          (ข)
                        </th>
                        <th className="text-center border border-1 border-black">
                          คะแนนรวม
                        </th>
                        <th className="text-center border border-1 border-black">
                          บันทึกเพิ่มเติมประกอบแบบสรุปการประเมินพฤติกรรม
                          <br />
                          การปฏิบัติราชการสมรรถนะหลัก 5 ด้าน
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="ps-2">
                          <strong>สมรรถนะ</strong>
                        </td>
                      </tr>
                      {formTwoData.map((item, index) => (
                        <tr key={item.id + index}>
                          <td
                            className="border border-1 border-black ps-2"
                            style={{ width: "400px" }}
                          >
                            {item.label}
                          </td>
                          <td
                            style={{ width: "100px" }}
                            className="text-center border border-1 border-black"
                          >
                            {checkExpectLevel(dataInfo.user_level_id)}
                          </td>
                          <td
                            style={{ width: "70px" }}
                            className="text-center border border-1 border-black"
                          >
                            {Number(item?.score)?.toFixed(2)}
                          </td>
                          <td
                            style={{ width: "70px" }}
                            className="text-center border border-1 border-black"
                          >
                            ร้อยละ {item.percentage}
                          </td>
                          <td
                            style={{ width: "70px" }}
                            className="text-center border border-1 border-black"
                          >
                            {item.score !== "" ? (
                              <>
                                {((item?.score * item?.percentage) / 100).toFixed(4)}
                              </>
                            ) : (
                              ""
                            )}
                          </td>
                          <td
                            style={{ width: "350px" }}
                            className="text-center border border-1 border-black"
                          ></td>
                        </tr>
                      ))}
                      <tr>
                        <td></td>
                        <td></td>
                        <td className="text-center">
                          <strong>รวม</strong>
                        </td>
                        <td className="text-center border border-1 border-black">
                          <strong>100 %</strong>
                        </td>
                        <td className="text-center border border-1 border-black">
                          <strong>{calculatedValues}</strong>
                        </td>
                      </tr>
                      <tr className="border border-1 border-black">
                        <td className="ps-2 ">
                          <strong>
                            แปลงคะแนน เป็นคะแนนการประเมินที่มีฐานคะแนนเต็ม 100 คะแนน
                            <br/>
                            (โดยนำ 100 * {calculatedValues} / 5)
                          </strong>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="text-center border border-1 border-black">
                          <strong>{FormData_1}</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Container>
              </div>
              <Col xs={8} md={6} lg={4} xl={12}>
                <div className={` 
                  ${windowSize.width < 576 
                    || (windowSize.width >= 768 && windowSize.width < 992 ) 
                    || (windowSize.width >= 992 && windowSize.width < 1200 )
                      ? "text-start ms-4" 
                      : "text-end me-4"
                    }
                `}>
                  <Button disabled={buttonLoading} style={{whiteSpace:"nowrap"}} className="mt-2 " color="success" onClick={downloadPDF}>
                    {buttonLoading === true ? (
                      <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                    ) : (
                      <i className="fa-solid fa-print pe-2"></i>
                    )}
                    ดาวน์โหลดแบบฟอร์มที่ 2
                  </Button>
                </div>
              </Col>
            </Fragment> }
        </ModalBody>
      </Modal>
    </Fragment>
  );
}

export default Form2PDF;